var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.83301 0.875C7.64523 0.875 8.42419 1.19766 8.99852 1.77199C9.57285 2.34632 9.89551 3.12527 9.89551 3.9375C9.89551 4.74973 9.57285 5.52869 8.99852 6.10301C8.42419 6.67735 7.64523 7 6.83301 7C6.02078 7 5.24182 6.67735 4.66749 6.10301C4.09316 5.52869 3.77051 4.74973 3.77051 3.9375C3.77051 3.12527 4.09316 2.34632 4.66749 1.77199C5.24182 1.19766 6.02078 0.875 6.83301 0.875ZM6.83301 8.53125C10.2171 8.53125 12.958 9.90172 12.958 11.5938V13.125H0.708008V11.5938C0.708008 9.90172 3.44895 8.53125 6.83301 8.53125Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.512644cf3559524678b49923307b7c25.svg";
export { ForwardRef as ReactComponent };